/**
 * Normalize any FastAPI/axios error into a STRING safe to render or toast.
 *
 * FastAPI returns three shapes in `response.data.detail`:
 *   1. a plain string   — our AppException (400/401/403/404/409/429)
 *   2. an ARRAY of error objects — Pydantic 422 validation:
 *        [{ type, loc, msg, input, ctx }, ...]
 *   3. (rarely) an object with a `msg`
 *
 * Rendering shape #2/#3 directly as a React child crashes with
 * "Objects are not valid as a React child (found: object with keys
 * {type, loc, msg, input, ctx})". Always pipe API errors through this.
 */
export function apiErrorMessage(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;

  if (typeof detail === "string" && detail.trim()) return detail;

  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => {
        if (typeof d === "string") return d;
        const loc = Array.isArray(d?.loc)
          ? d.loc.filter((p) => p !== "body" && p !== "query" && p !== "path").join(".")
          : "";
        const msg = typeof d?.msg === "string" ? d.msg : "";
        return loc && msg ? `${loc}: ${msg}` : msg || loc;
      })
      .filter(Boolean);
    if (msgs.length) return msgs.join("; ");
  }

  if (detail && typeof detail === "object" && typeof detail.msg === "string") {
    return detail.msg;
  }

  // Non-axios error (network failure, thrown Error) — use its message.
  if (!error?.response && typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }

  return fallback;
}

export default apiErrorMessage;
